import type React from "react";
import { useParams } from "react-router-dom";
import { ErrorBanner } from "../../../components/Error/ErrorBanner";
import { OneCardPage } from "../../../components/utils/OneCardPage";
import { useGetLocation } from "../../../hooks/getEntity.tsx";
import { useRequiredSelectedCompanyId } from "../../../hooks/useCompany";
import { useSelectedSchemeId } from "../../../hooks/useScheme";
import { statusEnum } from "../../../kubb";
import { NotFoundErrorForEntity } from "../../../model/error";
import LocationDisplay from "./LocationDisplay";

const LocationHomePage = (): React.ReactElement => {
  const company_id = useRequiredSelectedCompanyId();
  const scheme_id = useSelectedSchemeId();

  const { location_id } = useParams<{ location_id: string }>();

  if (location_id === undefined) {
    throw new Error("location_id must be specified.");
  }

  const { data, loading, error, refresh } = useGetLocation(
    location_id,
    company_id,
    scheme_id,
    [statusEnum.ACTIVE, statusEnum.DELETED],
  );

  if (error) {
    return (
      <OneCardPage
        headerTitle={"Location Detail"}
        breadcrumbs={[{ name: "Error" }]}
        setPageTitle={() => "Location: Error"}
      >
        <ErrorBanner error={error} />
      </OneCardPage>
    );
  }

  if (loading) {
    return (
      <OneCardPage
        headerTitle={"Location Detail"}
        loading={true}
        breadcrumbs={[{ name: "Loading" }]}
        setPageTitle={() => "Location: Loading"}
      />
    );
  }

  if (!data) {
    return (
      <OneCardPage
        headerTitle={"Location Detail"}
        breadcrumbs={[{ name: "Not Found" }]}
        setPageTitle={() => "Location: Not Found"}
      >
        <ErrorBanner error={NotFoundErrorForEntity("Location", location_id)} />
      </OneCardPage>
    );
  }

  return (
    <LocationDisplay
      data={data}
      loading={loading}
      error={error}
      refresh={refresh}
    />
  );
};

export default LocationHomePage;
